<div class="layout-ParentDiv innerDiv">
    <div class="layout-dashboard addPage">
        <div class="p-grid">
            <div class="p-col-12 mainFormPadding">
                <div class="card">
                    <p-toast key="toastmsg" position="top-right"></p-toast>
                    <form [formGroup]="categoryForm" *ngIf="this.categoryForm" (ngSubmit)="onSubmit()">
                        <div class="p-fluid p-formgrid p-grid m-0">
                            <div class="p-field p-col-12 div-border p-p-0">
                                <h3 class="head-page-title">
                                    View Category
                                </h3>
                            </div>
                        </div>
                        <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-12 p-fluid p-formgrid p-grid mainFormGap">
                                <div class="p-field p-col-8">
                                    <label for="name">Name</label>
                                    <input formControlName="name" type="text" pInputText class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f.name.errors }">
                                    <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                                        <div *ngIf="f.name.errors.required">Category Name is required</div>
                                        <div *ngIf="f.name.errors">Numbers, Space and Special characters not allowed.
                                        </div>
                                    </div>
                                </div>
                                <div class="p-field p-col-4  statusdivMain">
                                    <label for="firstname6">Status</label>
                                    <p-inputSwitch class="checkbox-mt-10" formControlName="status"></p-inputSwitch>
                                </div>
                                <!-- <div class="p-field p-col-4">
                                    <label for="status">Status</label>
                                    <p-dropdown inputId="status" [options]="statuses" formControlName="status"
                                        placeholder="Select" optionLabel="label"
                                        (ngModelChange)="onStatusSelect($event)"></p-dropdown>
                                    <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                                        <div *ngIf="f.status.errors.required">Please, Select Status</div>
                                    </div>
                                </div> -->

                                <div class="p-field p-col-12">
                                    <label for="description">Description</label>
                                    <textarea inputId="textarea" rows="3" cols="30" formControlName="description"
                                        pInputTextarea></textarea>
                                </div>
                                <div class="p-field p-col-12 uploadBtn">
                                    <div class="column banner-images col">
                                        <div class="imagediv d-flex gap-3 ">
                                            <img class="thumbnail-image" src="{{ imageProfile }}" />
                                            <ul class="actionList">
                                                <li>
                                                    <button type="button" class="editBtn"><img
                                                            src="../../../assets/images/backend-image/common-images/editeBtn.svg"></button>
                                                </li>
                                                <li>
                                                    <button type="button" class="deleteBtn"><img
                                                            src="../../../assets/images/backend-image/common-images/deleteBtn.svg"></button>
                                                </li>
                                            </ul>
                                        </div>

                                    </div>
                                </div>
                                <div class="p-field p-col-12">
                                    <div class="lineborderHR">
                                        <hr>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="button-set p-col-12 d-flex p-fluid p-jc-md-end bottom-footer">
                            <div class="d-flex">
                                <span *ngIf="!categoryDefault" class="mr-3">
                                    <button pButton pRipple label="Edit" icon="pi pi-pencil"
                                        (click)="editCategory(categoryId)"
                                        class="p-button-info save-btn p-mr-3"></button>
                                </span>
                                <!-- <button pButton pRipple label="Save" icon="pi pi-check" [disabled]="userForm.invalid"></button> -->
                                <!-- <button pButton pRipple label="Reset" icon="pi pi-times" type="reset" (click)="onReset()"></button> -->
                                <button pButton pRipple type="button" label="Cancel" icon="pi pi-times"
                                    class="cancel-btn" (click)="backLink()"></button>
                            </div>
                        </div>

                    </form>
                </div>
                <div class="button-set back">
                    <div class="p-fluid p-formgrid">
                        <p-toast></p-toast>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>